import { useMemo } from "react";
import useDevice from "src/hooks/useDevice";
import useDim from "src/hooks/useDim";

const usePhotoDetailDim = () => {
	const dim = useDim();
	const { device } = useDevice();

	return useMemo(() => {
		const width = device === "desktop" ? 0.9 * dim.width : dim.width;
		const height = device === "desktop" ? 0.9 * dim.height : dim.height;
		return {
			width: width,
			height: height,
		};
	}, [device, dim.height, dim.width]);
};
export default usePhotoDetailDim;
